var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAumicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63672 2.67187V0.527344H17.4727V9H15.3633M0.527344 15.3633V17.4727H6.89062V15.3633M0.527344 15.3633H6.89062M0.527344 15.3633L0.527344 13.2539H6.89062V15.3633M15.3633 15.3633H9V17.4727H15.3633V15.3633ZM15.3633 15.3633H17.4727V13.2539H11.1094V15.3633M2.63672 6.89062H3.72656M12.1992 6.89062H13.2539M15.3633 11.1445H0.527344V2.67187H15.3633V11.1445ZM7.94531 9C6.78196 9 5.83594 8.05398 5.83594 6.89062C5.83594 5.72727 6.78196 4.78125 7.94531 4.78125C9.10867 4.78125 10.0547 5.72727 10.0547 6.89062C10.0547 8.05398 9.10867 9 7.94531 9Z",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAumicon);
export default __webpack_public_path__ + "static/media/aumicon.6e69e7a6e2a91dfcbbe11b3e7f0d04ce.svg";
export { ForwardRef as ReactComponent };